import { ChatDestinationVO, PreLoginKcRealmVO } from '@repo/types'
import { PaymentType, REALM_NAMES_MAPPER, SOURCE_TYPES } from './constants'
import { KeyCloakRealm } from '@tecsinapse-org/keycloak-unified-authentication'

export const getDestinationDepartment = (destination?: ChatDestinationVO | null): string | undefined => {
  if (!destination) {
    return undefined
  }
  // @ts-expect-error
  return destination.infos.DEPARTMENT
}

export const getBrowser = (): string => {
  const userAgent = navigator.userAgent

  if (userAgent.includes('Firefox')) {
    return 'Firefox'
  } else if (userAgent.includes('Edg')) {
    return 'Edge'
  } else if (userAgent.includes('Chrome') && !userAgent.includes('Chromium')) {
    return 'Chrome'
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'Safari'
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera'
  } else {
    return 'Unknown Browser'
  }
}

export const isValidBrazilianPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.startsWith('55')
}

export const isReferral = (sourceType: string) => {
  return sourceType !== SOURCE_TYPES?.DEFAULT?.name && sourceType !== SOURCE_TYPES?.ECHO?.name
}

export const formatText = (text: string, limit: number): string => {
  return text.length > limit ? text.slice(0, limit).concat('...') : text
}

export const wait = async (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export function formatPaymentValue(value: string, type: PaymentType): string {
  let text = value ?? ''

  if (type === 'payment_link') {
    text = text.trim()

    if (text && !text.startsWith('https://') && !text.startsWith('upi://')) {
      text = 'https://' + text.replace(/^https?:\/\//, '')
    }
    return text
  }

  if (type === 'boleto') {
    text = text.replace(/\D/g, '').slice(0, 48)

    if (text.length > 0) {
      text = text
        .replace(/^(\d{5})(\d)/, '$1.$2')
        .replace(/^(\d{5}\.\d{5})(\d)/, '$1 $2')
        .replace(/^(\d{5}\.\d{5} \d{5})(\d)/, '$1.$2')
        .replace(/^(\d{5}\.\d{5} \d{5}\.\d{6})(\d)/, '$1 $2')
        .replace(/^(\d{5}\.\d{5} \d{5}\.\d{6} \d{5})(\d)/, '$1.$2')
    }

    return text
  }

  return text
}

export const mapRealmAlias = (options: PreLoginKcRealmVO[] | KeyCloakRealm[]) => {
  return options.map(option => {
    const realmAlias = REALM_NAMES_MAPPER.find(realm => realm.originalName === option.realm)?.newName || option.realm
    return { ...option, realmAlias }
  })
}
